<template>
    <div class="edu_pages">
      <div class="edu_pages_content_box">
        <div class="edu_page_title_box">
          <div class="title_box">
            <div class="color_lump_box"></div>
            <span>人员管理</span>
          </div>
          <div class="edu_operation_box">
            <el-input
              class="input"
              size="mini"
              style="width:200px"
              v-model.trim="searchData.userPhone"
              placeholder="手机号"
              clearable
            ></el-input>
            <!-- <el-select
              class="select"
              size="mini"
              style="width:200px;margin-left:5px"
              v-model="searchData.hiddenDangerStatus"
              placeholder="请选择隐患状态"
              clearable
            >
              <el-option
                v-for="(item, index) in $store.state.select.hiddenDangerStatus"
                :key="index"
                :label="item.nameOne"
                :value="item.id"
              ></el-option>
            </el-select> -->
            <div
              class="search_icon_box button-box"
              @click="getList()"
            >
              <div></div>
              <span>搜索</span>
            </div>
            <el-button type="primary" size="mini" icon="el-icon-download" @click="download">下载导入模板</el-button>
            <!--  -->

            <el-upload
              style="margin-left:10px"
              class="upload-demo"
              accept=".doc, .docx, .xls, .xlsx, .ppt, .pptx, .pdf"
              :action = "$store.state.config.baseURL + '/hxg/batch/add/hxg/user'"
              :on-success="handleSuccess"
              :show-file-list="false"
              :file-list="fileList"
              :data="{eduId: $store.getters.getEduData.eduId}"
              :headers="headers"
            >
              <el-button type="primary" size="mini" icon="el-icon-upload2">导入</el-button>
            </el-upload>
            <el-button type="primary" size="mini" icon="el-icon-plus" @click="add" style="margin-left:10px">新增</el-button>
          </div>
        </div>
        <div class="edu_pages_content_body_box">
          <div class="edu_table_box">
            <el-table
              :data="resData.list"
              height="100%"
              :header-cell-style="{ background: '#DDE4FF', color: '#474859' }"
              class="table_box"
            >
              <el-table-column label="序号" width="70" align="center">
                <template slot-scope="scope">
                  {{
                    searchData.pageSize * (searchData.pageNum - 1) +
                      scope.$index +
                      1
                  }}
                </template>
              </el-table-column>
              <el-table-column
                prop="userName"
                label="姓名"
                width="120"
                align="center"
              >
              </el-table-column>
              
              <!-- <el-table-column label="头像" align="center">
                <template slot-scope="scope">
                    <el-avatar v-if="scope.row.headPortrait" :src="$store.state.config.fileUrl + scope.row.headPortrait"></el-avatar>
                    <el-avatar v-else src="https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png"></el-avatar>
                    
                </template>
              </el-table-column> -->
              <el-table-column
                prop="userPhone"
                label="手机号"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="sex"
                label="性别"
                width="120"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.sex == 1">男</span>
                  <span v-else-if="scope.row.sex == 2">女</span>
                  <span v-else></span>
                </template>
              </el-table-column>
              <el-table-column
                prop="serviceUnit"
                label="服务单位"
                align="center"
              >
              </el-table-column>
              <!-- <el-table-column
                prop="status"
                label="状态"
                show-overflow-tooltip
                align="center"
              >
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status ? 'success' : 'warning'" plain>{{ scope.row.status ? '正常' : '禁用' }}</el-tag>
                </template>
              </el-table-column> -->
              <!-- <el-table-column
                prop="time"
                label="添加时间" align="center"
              >
                <template slot-scope="scope">
                  {{ $Common.dateFormatDateTwo(scope.row.time) }}
                </template>
              </el-table-column> -->
              <el-table-column label="操作" width="180" align="center">
                <template slot-scope="scope">
                  <el-button type="primary" size="mini" @click="edit(scope.row)">编辑</el-button>
                  <el-button type="danger" size="mini" @click="delete_row(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="edu_pagination_box">
            <el-pagination
              background
              @current-change="handleCurrentChange"
              :current-page="resData.pageNum"
              :page-size="resData.pageSize"
              layout="total, prev, pager, next, jumper"
              :total="resData.total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
        <el-dialog :visible.sync="editShow" :title="dialogType=='add' ? '新增' : '编辑'" width="600px" append-to-body :before-close="closeDialog">
            <el-form :model="column_row" label-width="120px" size="mini" :rules="rules" ref="ruleForm">
                <el-form-item label="姓名" prop="userName">
                    <el-input v-model="column_row.userName"/>
                </el-form-item>
                <el-form-item label="性别" prop="sex">
                  <el-radio v-model="column_row.sex" label="1">男</el-radio>
                  <el-radio v-model="column_row.sex" label="2">女</el-radio>
                </el-form-item>
                <el-form-item label="手机号" prop="userPhone">
                    <el-input v-model="column_row.userPhone"/>
                </el-form-item>
                <el-form-item label="服务单位" prop="serviceUnit">
                    <el-input v-model="column_row.serviceUnit"/>
                </el-form-item>
                <el-form-item label="用户密码" prop="userPwd">
                    <el-input type="password" v-model="column_row.userPwd"/>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeDialog" size="mini">取 消</el-button>
                <el-button type="primary" @click="submit_edit" size="mini">确 定</el-button>
            </span>
        </el-dialog>
    </div>
  </template>
  
  <script>
  const CryptoJS = require("crypto-js"); //引用加密源码js

  export default {
    name: "nursingPost",
    data() {
      var reg = /^1[3456789]\d{9}$/;
      var checkPhone = (rule, value, callback) => {
        if (value === "") {
          callback(new Error("手机号不能为空"));
        } else if (!reg.test(value)) {
          callback(new Error("手机号校验不通过"));
        } else {
          callback();
        }
      };
      return {
        rules: {
          userName: [{ required: true, trigger: "blur", message: '用户名称不能为空'  }],
          sex: [{ required: true, trigger: "blur", message: '性别不能为空'  }],
          serviceUnit: [{ required: true, trigger: "blur", message: '服务单位不能为空'  }],
          userPhone: [{ required: true, validator: checkPhone, trigger: "blur" }],
          userPwd: [{ required: true, trigger: "blur",  message: '用户密码不能为空' }],
        },
        eduInfo: JSON.parse(sessionStorage.getItem("eduInfo")),
        searchData: {
          eduId: "",
          pageNum: 1,
          pageSize: 20,
          userPhone: ""
        //   hiddenDangerStatus: ""
        },
        // 隐患督办数据
        resData: {
          list: [],
          pageNum: 1,
          pageSize: 20,
          pages: 0,
          total: 0
        },
        checkResize: 0,
        hiddenDangerId: 0,
        superviseResize: 0,
        selData: {},
        fileResize: 0,
        editShow:false,
        dialogType:'add',
        column_row:{
          sex:'1'
        },
        fileList:[]
      };
    },
    computed:{
      headers(){
        let headers = {}
        // sign 验证
        let appKey = "shuangan20200417";
        let param = {
          eduId: this.$store.getters.getEduData.eduId
        };
        // let isFormData = config.isFormData;
        let paramKey = [];
        let sign = "";
        // console.log(param)
        // console.log(JSON.stringify(param)+1)
        // console.log(typeof param)
        // console.log(Array.isArray(param))
        // return
        if (typeof param == "object" && !Array.isArray(param)) {
          //  console.log(2)
          if (param != null && param != undefined && param != "") {
            var arr = [];
            param = Object.assign({}, param);
            for (var i in param) {
              arr.push(i);
            }
            // console.log(arr)
            paramKey = arr.sort();
            // console.log(paramKey)
          }
          // if ()
          // // 判断是否有参数
          if (paramKey.length > 0) {
            sign = "";
            let paramString = JSON.stringify(param);
            // console.log(paramString,1111);
            paramString = paramString.replace(/\s+/g, "").replace("s*|\t|\r|\n/g", "");
            // console.log(paramString);
            sign = appKey + paramString;
          }
          // console.log(config.method == "get")
          if ((paramKey.length > 0 )) {
            sign = "";
            paramKey.forEach((element) => {
              // console.log(element)
              // console.log(param)
              if (element != "file") {
                sign = sign + param[element].toString();
              }
            });
            sign = sign + appKey;
            // console.log(param[paramKey])
            // console.log(111)
          }
        }
        if (Array.isArray(param)) {
          sign = appKey + JSON.stringify(param);
        }
        if (!param) {
          sign = sign + appKey;
        }
        var localTime2 = parseInt(Date.parse(new Date()) / 1000);
        // let nonce = guid();
        var localTime1 = sessionStorage.getItem('localTime1');
        var serverTime = sessionStorage.getItem('serverTime');
        // console.log(localTime1,localTime2,serverTime)
        var timeStamp = Number(localTime2) - Number(localTime1) + Number(serverTime);
        // console.log(timeStamp)
        sign = sign + timeStamp;
        // console.log(sign)
        sign = CryptoJS.MD5(sign);

        // console.log(param,222222)

        var userInfo = this.$store.getters.getUserInfo;
        if (userInfo != false) {
          headers.token = userInfo.token;
          headers.timestamp = timeStamp;
          headers.sign = sign;
          // headers.nonce = nonce;
          headers.userId = userInfo.userId;
        }
        // console.log(headers)
        return headers;
        
      },
    },
    mounted() {
      this.getList();
    },
    methods: {
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      handleCurrentChange(val) {
        this.searchData.pageNum = val;
        // console.log(`当前页: ${val}`);
        this.getHiddenDangerData();
      },
      getList(){
        // console.log(eduId, "=========")
        this.searchData.eduId = this.$store.getters.getEduData.eduId;
        this.searchData.pageNum = 1;
        this.getHiddenDangerData();
      },
      // 获取隐患数据
      async getHiddenDangerData() {
        console.log(this.searchData,'this.searchData')
        // this.searchData.eduId = this.eduInfo.eduId;
        // this.searchData.educationBureauType = this.eduInfo.eduBuresuType;
        // this.searchData.regionCode = this.eduInfo.regionCode;
        let res = await this.$Http.getEduhxgList(this.searchData, true );
        if (res.code == 200) {
          this.resData = res.data;
        } else if (res.code == 101) {
          this.resData.list = [];
          this.total = 0;
        } else {
          this.$message({
            type: "error",
            message: res.messsage
          });
        }
      },
      // 新增弹框
      add(){
        this.dialogType = 'add';
        this.column_row = {sex:'1'};
        this.editShow = true;
      },
    //   编辑
      edit(row){
        this.dialogType = 'edit';
        this.column_row = Object.assign({},row);
        this.column_row.sex = this.column_row.sex + ''
        this.editShow = true;
      },
      //下载导入模板
      download(){
        let a = document.createElement("a");
        // 下载名字
        a.download = '护学岗导入模板';
        //url
        a.href = 'https://school.zzsasoft.com/uploads/files/templates/hxg_user.xlsx';
        //合成函数，执行下载
        a.dispatchEvent(new MouseEvent("click"));
      },
      

      //导入成功回调
      handleSuccess(res){
        if(res.code == 200){
          this.$message.success('导入成功')
          this.getList();
        }else{
          this.$message.error(res.messsage)
          // console.log(res.messsage)
        }
      },
    //   提交
    submit_edit(){
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            this.submit1();
          } else {
            // console.log('error submit!!');
            return false;
          }
        });
      },
      async submit1(){
        let res = ''
        if(this.dialogType == 'add'){
            this.column_row.eduId = this.$store.getters.getEduData.eduId;
            res = await this.$Http.addEduhxgUser(this.column_row);
        }else{
            res = await this.$Http.editEduhxgUser(this.column_row);
        }
        if (res.code == 200) {
            this.$message({
                type: "success",
                message: res.messsage
            });
            this.getList();
            this.closeDialog();
        }else{
            this.$message({
                type: "error",
                message: res.messsage
            });
        }
      },
      closeDialog(){
        this.resetForm('ruleForm')
        this.editShow = false;
      },
      // 删除
       delete_row(row){
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            this.sure_delete(row)
        })
      },
      async sure_delete(row){
        let res = await this.$Http.deleteEduhxgUser(row);
        if (res.code == 200) {
            this.$message.success('删除成功');
            this.getList();
        }
      },
      // 查看隐患详情信息
      getDetail(id) {
        this.hiddenDangerId = id;
        this.checkResize++;
      },
      // 查看下发文件
      getFile(row) {
        this.selData = row;
        this.fileResize++;
      },
      jump() {
        this.$Common.pageJump("/eduHiddenDangerSupervise", 2);
      },
      // 督办
      supervise(row) {
        this.selData = row;
        this.superviseResize++;
      }
    }
  };
  </script>
  <style lang="scss">
    .edu_pages{
      input[type="file"]{
        display: none;
      }
    }
  </style>
  <style scoped lang="scss">
  .edu_header_title {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding: 0 2rem;
    cursor: pointer;
    &.active {
      background-color: rgba(28, 113, 251, 0.3);
      color: #1c71fb;
      border-bottom: 3px solid #1c71fb;
    }
  }
  .edu_pages_content_header {
    .demo-form-inline {
      height: 100%;
      display: flex;
      align-items: center;
    }
    .el-form-item {
      .input,
      .select {
        width: 180px;
      }
      .image-slot {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
  .el-table {
    overflow: scroll;
    scrollbar-width: none;
    &:before {
      display: none;
    }
    .button {
      margin-bottom: 10px;
    }
  }
  
  @import "../../../../../public/css/edu_pages.scss"
  </style>
  